module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-preloader"
  }, [_c('div', {
    staticClass: "c-preloader__spinner"
  }, [_c('div', {
    staticClass: "c-preloader__spinner-dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-preloader__spinner-dot2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94971932"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingAnimation.vue
// module id = 86
// module chunks = 0